module.exports = __webpack_public_path__ + "static/newtritious-f7975b4053965b8429b74d25c648de9a.png";